import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getToken } from '../context/AuthContext';
import PremiumPrompt from './PremiumPrompt';
import config from '../config';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function AddToWatchlist({ symbol }) {
  const { user, isSubscribed } = useAuth();
  const { premiumFeaturesEnabled } = useFlags();
  const [inWatchlist, setInWatchlist] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  const hasPremium = isSubscribed || premiumFeaturesEnabled;

  useEffect(() => {
    if (!user || !hasPremium || !symbol) return;
    fetch(`${config.apiBaseURL}/api/watchlists`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then(r => r.json())
      .then(data => {
        const syms = (data.stocks || []).map(s => s.symbol);
        setInWatchlist(syms.includes(symbol.toUpperCase()));
      })
      .catch(() => {});
  }, [user, hasPremium, symbol]);

  const handleClick = async () => {
    if (!premiumFeaturesEnabled && !isSubscribed) {
      setShowPrompt(true);
      return;
    }

    setLoading(true);
    try {
      if (inWatchlist) {
        await fetch(`${config.apiBaseURL}/api/watchlists/stocks/${symbol}`, {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        setInWatchlist(false);
      } else {
        await fetch(`${config.apiBaseURL}/api/watchlists/stocks`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({ symbol }),
        });
        setInWatchlist(true);
      }
    } catch {
      // silently ignore — button just reverts to previous state
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`btn-watchlist${inWatchlist ? ' btn-watchlist--active' : ''}`}
        onClick={handleClick}
        disabled={loading}
        title={inWatchlist ? 'Remove from watchlist' : 'Add to watchlist'}
      >
        {inWatchlist ? '★ In Watchlist' : '☆ Add to Watchlist'}
      </button>

      {showPrompt && (
        <div className="premium-prompt-overlay" onClick={() => setShowPrompt(false)}>
          <div onClick={e => e.stopPropagation()}>
            <PremiumPrompt feature="Watchlists" />
            <button className="btn-link" style={{ marginTop: 8 }} onClick={() => setShowPrompt(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
